<template>
  <b-modal
    v-model="visible"
    :title="`Gán nhà cung cấp chính cho ${childName}`"
    hide-footer
    @hidden="$emit('close')"
  >
    <p class="mb-1 text-muted small">
      KH/NCC phụ: <strong class="text-dark">{{ childName }}</strong>
    </p>
    <p v-if="currentParentName" class="mb-2 text-muted small">
      NCC chính hiện tại: <strong class="text-dark">{{ currentParentName }}</strong>
    </p>

    <label class="font-weight-500 mt-2 mb-1">Chọn KH/NCC chính mới:</label>
    <SupplierAutosuggest
      v-model="selectedParentId"
      :initial-label="selectedParentLabel"
      placeholder="Tìm kiếm theo tên hoặc SĐT..."
      @selected="onSelected"
    />

    <div class="d-flex justify-content-end mt-3">
      <b-button
        size="sm"
        variant="outline-secondary"
        class="mr-2"
        :disabled="isSubmitting"
        @click="visible = false"
      >
        Hủy
      </b-button>
      <b-button
        size="sm"
        variant="primary"
        :disabled="!selectedParentId || isSubmitting"
        @click="onSubmit"
      >
        <b-spinner v-if="isSubmitting" small class="mr-1" />
        {{ isSubmitting ? 'Đang lưu...' : 'Gán' }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';
import SupplierAutosuggest from '@/view/components/suppliers/SupplierAutosuggest.vue';

export default {
  name: 'AssignParentModal',

  components: { SupplierAutosuggest },

  props: {
    childId: { type: Number, required: true },
    childName: { type: String, default: '' },
    currentParentId: { type: Number, default: null },
    currentParentName: { type: String, default: '' },
  },

  data() {
    return {
      visible: true,
      isSubmitting: false,
      selectedParentId: null,
      selectedParentLabel: '',
    };
  },

  methods: {
    onSelected(item) {
      if (item) {
        this.selectedParentId = item.id;
        this.selectedParentLabel = item.fullName || '';
      } else {
        this.selectedParentId = null;
        this.selectedParentLabel = '';
      }
    },

    async onSubmit() {
      if (!this.selectedParentId) return;
      this.isSubmitting = true;
      try {
        await ApiService.put(`v1/customers/${this.childId}`, {
          parentId: this.selectedParentId,
        });
        makeToastSuccess(
          `Đã gán "${this.childName}" làm NCC phụ của "${this.selectedParentLabel}"`,
        );
        this.$emit('assigned');
        this.visible = false;
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || 'Có lỗi xảy ra';
        makeToastFaile(msg);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
